export const appointmentQueryKeys = [
  'appointment-events',
  'overview-appointments',
  'appointment-queue',
  'patient-appointments'
];

export const clinicalNotesQueryKeys = [
  'clinicalNotes',
  'overview-clinical-notes',
  'clinicalNotesInfinite',
  'checkPatientNotes'
];

export const overviewLedgerQueryKeys = ['overview-ledger', 'overview-balance-ledger'];

export const MESSAGES_COUNT_QUERY_KEY = 'messagesCount';
